<template>
  <m-text v-bind="{ ...$attrs }" :variant="$attrs.variant ?? 'body-sm'">
    <!-- TODO: Published? -->
    {{
      $t('auth.common.messages.opendockIsPoweredByLoadsmartIncDateAllRightsReserved', {
        date: new Date().getFullYear()
      })
    }}
  </m-text>
</template>
<script>
/**
 * Copyright text with dynamic copyright year
 * @displayName Copyright Text
 */
export default {
  name: 'CopyrightText'
};
</script>
